// extracted by mini-css-extract-plugin
export default {"header":"HeaderComponent_header__Yy1Dw","avatar":"HeaderComponent_avatar__VMylU","name":"HeaderComponent_name__o1QDZ"};